const REQUIRED_FIELDS_BY_COUNTRY = {
	bg: ['city', 'postalCode'],
	ee: ['addressLine1', 'postalCode', 'city'],
	sk: ['city', 'postalCode', 'street', 'building'],
	default: ['city', 'postalCode'],
};

export const checkRequiredFieldsForCountry = (
	countryShort,
	addressFormInputs,
) => {
	const requiredFields =
		REQUIRED_FIELDS_BY_COUNTRY[countryShort] ||
		REQUIRED_FIELDS_BY_COUNTRY.default;

	return requiredFields.every((field) => Boolean(addressFormInputs[field]));
};
